import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faMap, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { activarSubscripcion } from "../../services/usuario";

const ConfirmacionPago = () => {
  const [estadoPago, setEstadoPago] = useState("Procesando…");
  useEffect(() => {
    activarSubscripcion();
  }, []);

  useEffect(() => {
    const requestActivarSubscripcion = async () => {
      const estado = await activarSubscripcion();
      setEstadoPago(estado.status);
    };
    requestActivarSubscripcion();
  }, []);

  return (
    <div id="watermark" className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md={8} className="text-center">
            <h1 className="mb-3">Estamos procesando tu pago…</h1>
            <p className="lead">
              Gracias por tu compra. En este momento estamos validando la
              transacción.
            </p>
            <p>
              En unos momentos recibirás un correo con la confirmación y los
              detalles de tu pago.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center mb-5">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <h4 className="mb-3 text-center">Estado del Pago</h4>
                <Row className="mb-2">
                  <Col>Estado:</Col>
                  <Col className="text-end fw-bold text-warning">
                    {estadoPago}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>Fecha:</Col>
                  <Col className="text-end">
                    {new Date().toLocaleDateString()}
                  </Col>
                </Row>
                <p className="text-muted mt-3 text-center">
                  Este estado se actualizará automáticamente cuando tengamos la
                  confirmación del proveedor de pagos.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col md={6}>
            <p className="fw-bold mb-4">¿Necesitas ayuda? ¡Contáctanos!</p>
            <p>
              <FontAwesomeIcon icon={faPhone} className="me-2" />
              <a href="https://wa.me/+573142771096">(+57) 3142771096</a>
              <br />
              <a href="tel:+573164725531">(+57) 3164725531</a>
            </p>
            <p>
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              <a href="mailto:aureamedicina2020@gmail.com">
                aureamedicina2020@gmail.com
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ConfirmacionPago;
